import React, { memo } from 'react';
import { ACCIDENT_SCENARIOS } from './sketchScenarios';

// ========== COMPONENTA SCHIȚĂ ACCIDENT (SVG) ==========
export const AccidentSketch = memo(({ data, width = 380, height = 280, showLegend = true }) => {
  if (!data) return null;
  
  const W = width;
  const H = height;
  const CX = W / 2;
  const CY = H / 2;
  
  // Verifică dacă avem scenariu predefinit sau date directe
  const scenario = data.scenarioId ? ACCIDENT_SCENARIOS[data.scenarioId] : null;
  const config = scenario || data;
  const tipDrum = config.tipDrum || 'intersectie';
  
  // Scala pentru a converti coordonatele în SVG
  const scale = Math.min(W, H) / 220;
  
  const getVehiclePos = (vehicleData) => ({
    x: CX + (vehicleData?.x || 0) * scale,
    y: CY + (vehicleData?.y || 0) * scale,
    rotation: vehicleData?.rotation || 0
  });
  
  const posA = getVehiclePos(config.vehiculA);
  const posB = getVehiclePos(config.vehiculB);
  
  const impactPos = config.impactPoint ? {
    x: CX + (config.impactPoint.x || 0) * scale,
    y: CY + (config.impactPoint.y || 0) * scale
  } : {
    x: (posA.x + posB.x) / 2,
    y: (posA.y + posB.y) / 2
  };

  // Componenta pentru mașină
  const Car = ({ x, y, rotation, color, textColor, label }) => (
    <g transform={`translate(${x}, ${y}) rotate(${rotation})`}>
      {/* Corpul mașinii */}
      <rect x="-12" y="-20" width="24" height="40" rx="5" fill={color} stroke="#333" strokeWidth="1.5"/>
      {/* Parbriz (față) */}
      <rect x="-8" y="-16" width="16" height="10" fill="#87CEEB" rx="2" opacity="0.85"/>
      {/* Lunetă (spate) */}
      <rect x="-8" y="8" width="16" height="8" fill="#87CEEB" rx="2" opacity="0.85"/>
      {/* Faruri față */}
      <rect x="-10" y="-19" width="5" height="3" fill="#FFE066" rx="1"/>
      <rect x="5" y="-19" width="5" height="3" fill="#FFE066" rx="1"/>
      {/* Stopuri spate */}
      <rect x="-10" y="16" width="5" height="3" fill="#FF6B6B" rx="1"/>
      <rect x="5" y="16" width="5" height="3" fill="#FF6B6B" rx="1"/>
      {/* Săgeată direcție */}
      <polygon points="0,-25 -5,-30 5,-30" fill={color} stroke="#333" strokeWidth="1"/>
      {/* Label */}
      <circle cx="0" cy="0" r="9" fill="rgba(255,255,255,0.95)" stroke="#333" strokeWidth="0.5"/>
      <text x="0" y="4" textAnchor="middle" fill={textColor} fontWeight="bold" fontSize="11">{label}</text>
    </g>
  );

  // Desenează drumul în funcție de tip
  const renderRoad = () => {
    switch (tipDrum) {
      case 'intersectie':
        return (
          <g>
            {/* Fundal verde */}
            <rect x="0" y="0" width={W} height={H} fill="#c8e6c9"/>
            {/* Drum vertical */}
            <rect x={CX - 35} y="0" width="70" height={H} fill="#555"/>
            {/* Drum orizontal */}
            <rect x="0" y={CY - 35} width={W} height="70" fill="#555"/>
            {/* Linii margine - vertical */}
            <line x1={CX - 35} y1="0" x2={CX - 35} y2={CY - 35} stroke="white" strokeWidth="2"/>
            <line x1={CX + 35} y1="0" x2={CX + 35} y2={CY - 35} stroke="white" strokeWidth="2"/>
            <line x1={CX - 35} y1={CY + 35} x2={CX - 35} y2={H} stroke="white" strokeWidth="2"/>
            <line x1={CX + 35} y1={CY + 35} x2={CX + 35} y2={H} stroke="white" strokeWidth="2"/>
            {/* Linii margine - orizontal */}
            <line x1="0" y1={CY - 35} x2={CX - 35} y2={CY - 35} stroke="white" strokeWidth="2"/>
            <line x1="0" y1={CY + 35} x2={CX - 35} y2={CY + 35} stroke="white" strokeWidth="2"/>
            <line x1={CX + 35} y1={CY - 35} x2={W} y2={CY - 35} stroke="white" strokeWidth="2"/>
            <line x1={CX + 35} y1={CY + 35} x2={W} y2={CY + 35} stroke="white" strokeWidth="2"/>
            {/* Linii centrale întrerupte */}
            <line x1={CX} y1="0" x2={CX} y2={CY - 40} stroke="white" strokeWidth="2" strokeDasharray="8,8"/>
            <line x1={CX} y1={CY + 40} x2={CX} y2={H} stroke="white" strokeWidth="2" strokeDasharray="8,8"/>
            <line x1="0" y1={CY} x2={CX - 40} y2={CY} stroke="white" strokeWidth="2" strokeDasharray="8,8"/>
            <line x1={CX + 40} y1={CY} x2={W} y2={CY} stroke="white" strokeWidth="2" strokeDasharray="8,8"/>
          </g>
        );
        
      case 'drum_drept':
        return (
          <g>
            {/* Fundal verde */}
            <rect x="0" y="0" width={W} height={H} fill="#c8e6c9"/>
            {/* Drum */}
            <rect x={CX - 45} y="0" width="90" height={H} fill="#555"/>
            {/* Linii margine */}
            <line x1={CX - 45} y1="0" x2={CX - 45} y2={H} stroke="white" strokeWidth="2.5"/>
            <line x1={CX + 45} y1="0" x2={CX + 45} y2={H} stroke="white" strokeWidth="2.5"/>
            {/* Linie centrală întreruptă */}
            <line x1={CX} y1="0" x2={CX} y2={H} stroke="white" strokeWidth="2" strokeDasharray="12,8"/>
          </g>
        );
        
      case 'sens_giratoriu':
        return (
          <g>
            {/* Fundal verde */}
            <rect x="0" y="0" width={W} height={H} fill="#c8e6c9"/>
            {/* Cercul giratoriu */}
            <circle cx={CX} cy={CY} r="60" fill="none" stroke="#555" strokeWidth="40"/>
            {/* Linie exterioară */}
            <circle cx={CX} cy={CY} r="80" fill="none" stroke="white" strokeWidth="2"/>
            {/* Insula centrală */}
            <circle cx={CX} cy={CY} r="28" fill="#7CB342" stroke="#5a8f2f" strokeWidth="2"/>
            {/* Săgeți direcție */}
            <polygon points={`${CX + 55},${CY - 25} ${CX + 50},${CY - 18} ${CX + 60},${CY - 18}`} fill="white"/>
            <polygon points={`${CX - 55},${CY + 25} ${CX - 60},${CY + 18} ${CX - 50},${CY + 18}`} fill="white"/>
            {/* Străzi de acces */}
            <rect x={CX - 22} y={CY + 80} width="44" height="60" fill="#555"/>
            <rect x={CX - 22} y="0" width="44" height={CY - 80} fill="#555"/>
            <rect x="0" y={CY - 22} width={CX - 80} height="44" fill="#555"/>
            <rect x={CX + 80} y={CY - 22} width={W - CX - 80} height="44" fill="#555"/>
          </g>
        );
        
      case 'parcare':
        return (
          <g>
            {/* Fundal asfalt */}
            <rect x="0" y="0" width={W} height={H} fill="#888"/>
            {/* Zona de parcare */}
            <rect x="20" y={CY - 50} width={W - 40} height="100" fill="#666"/>
            {/* Locuri de parcare */}
            {[60, 110, 160, 210, 260, 310].map(x => (
              <line key={x} x1={x} y1={CY - 50} x2={x} y2={CY + 50} stroke="white" strokeWidth="2"/>
            ))}
            {/* Culoar de circulație */}
            <rect x="20" y={CY + 55} width={W - 40} height="35" fill="#555"/>
            <line x1="20" y1={CY + 72} x2={W - 20} y2={CY + 72} stroke="white" strokeWidth="2" strokeDasharray="8,6"/>
            <text x={CX} y={CY - 60} textAnchor="middle" fill="#555" fontSize="10" fontWeight="bold">PARCARE</text>
          </g>
        );
        
      default:
        return (
          <g>
            <rect x="0" y="0" width={W} height={H} fill="#c8e6c9"/>
            <rect x={CX - 45} y="0" width="90" height={H} fill="#555"/>
            <line x1={CX} y1="0" x2={CX} y2={H} stroke="white" strokeWidth="2" strokeDasharray="12,8"/>
          </g>
        );
    }
  };
  
  return (
    <svg width={W} height={H} style={{ background: '#f0f0f0', borderRadius: '8px', border: '2px solid #dee2e6' }}>
      {/* Drumul */}
      {renderRoad()}
      
      {/* Numele scenariului */}
      {scenario && (
        <text x={CX} y="16" textAnchor="middle" fill="#333" fontSize="10" fontWeight="bold">
          {scenario.name}
        </text>
      )}
      
      {/* Numele străzii */}
      {data.numeStrada && (
        <text x={CX} y={scenario ? 28 : 16} textAnchor="middle" fill="#444" fontSize="9">
          {data.numeStrada}
        </text>
      )}
      
      {/* Mașinile */}
      <Car x={posA.x} y={posA.y} rotation={posA.rotation} color="#0a3c91" textColor="#0a3c91" label="A" />
      <Car x={posB.x} y={posB.y} rotation={posB.rotation} color="#ffd80e" textColor="#333" label="B" />
      
      {/* Punctul de impact */}
      <g transform={`translate(${impactPos.x}, ${impactPos.y})`}>
        <circle r="12" fill="rgba(255,50,50,0.15)" stroke="#ff3333" strokeWidth="2"/>
        <text x="0" y="5" textAnchor="middle" fill="#ff3333" fontWeight="bold" fontSize="14">✕</text>
      </g>
      
      {/* Legenda */}
      {showLegend && (
        <g>
          <rect x="5" y={H - 42} width="85" height="37" fill="white" rx="4" stroke="#ddd"/>
          <rect x="10" y={H - 34} width="14" height="10" fill="#0a3c91" rx="2"/>
          <text x="28" y={H - 25} fontSize="9" fill="#333">Vehicul A</text>
          <rect x="10" y={H - 21} width="14" height="10" fill="#ffd80e" rx="2" stroke="#333" strokeWidth="0.5"/>
          <text x="28" y={H - 12} fontSize="9" fill="#333">Vehicul B</text>
        </g>
      )}
      
      {/* Indicație */}
      <text x={W - 8} y={H - 6} textAnchor="end" fill="#999" fontSize="7">
        Schiță generată AI
      </text>
    </svg>
  );
});

// ========== PREVIEW SCENARIU (pentru selector) ==========
export const ScenarioPreview = memo(({ scenarioId, width = 120, height = 90 }) => {
  const scenario = ACCIDENT_SCENARIOS[scenarioId];
  if (!scenario) return null;
  
  return (
    <AccidentSketch 
      data={{ ...scenario, scenarioId }} 
      width={width} 
      height={height} 
      showLegend={false}
    />
  );
});

// ========== GRILĂ DESEN MANUAL ==========
export const ManualSketchGrid = memo(({ width = 380, height = 280 }) => {
  const cellSize = 20;
  const cols = Math.floor(width / cellSize);
  const rows = Math.floor(height / cellSize);
  
  return (
    <svg width={width} height={height} style={{ background: '#fff', borderRadius: '8px', border: '2px solid #dee2e6' }}>
      {Array.from({ length: cols + 1 }).map((_, i) => (
        <line key={`v${i}`} x1={i * cellSize} y1="0" x2={i * cellSize} y2={height} stroke="#e5e7eb" strokeWidth="1"/>
      ))}
      {Array.from({ length: rows + 1 }).map((_, i) => (
        <line key={`h${i}`} x1="0" y1={i * cellSize} x2={width} y2={i * cellSize} stroke="#e5e7eb" strokeWidth="1"/>
      ))}
      <text x={width / 2} y={height / 2 - 10} textAnchor="middle" fill="#9CA3AF" fontSize="13">
        Schița se completează manual pe hârtie
      </text>
      <text x={width / 2} y={height / 2 + 10} textAnchor="middle" fill="#9CA3AF" fontSize="11">
        În PDF va apărea o grilă pentru desen
      </text>
    </svg>
  );
});

// ========== RADIO GROUP ==========
export const RadioGroup = memo(({ value, onChange }) => (
  <div className="radio-group">
    <button type="button" className={`radio-option ${value === 'da' ? 'selected' : ''}`} onClick={() => onChange('da')}>Da</button>
    <button type="button" className={`radio-option ${value === 'nu' ? 'selected' : ''}`} onClick={() => onChange('nu')}>Nu</button>
  </div>
));